import { ActionBase } from "./models";

export interface MAREditedAction extends ActionBase {
  reason?: string;
  MARTimes?: string[];
  MARDaysOfTheWeek?: string[];
  MARNotes?: string;
  MARFrequency?: string;
}

export namespace MAREditedAction {
  export function getMAREditedReason(obj: Partial<MAREditedAction>): string {
    const times = obj.MARTimes ? `Times: ${obj.MARTimes.join(",")}` : "";
    const daysOfTheWeek = obj.MARDaysOfTheWeek
      ? `Days of the Week: ${obj.MARDaysOfTheWeek.join(",")}`
      : "";
    const notes = obj.MARNotes ? `Notes: ${obj.MARNotes}` : "";
    const frequency = obj.MARFrequency
      ? `Administration: ${obj.MARFrequency}`
      : "";
    return [times, daysOfTheWeek, notes, frequency]
      .filter((part) => part)
      .join("; ");
  }
}



// WEBPACK FOOTER //
// ./src/models/order-management/MAREditedAction.ts